// dashboard-shell.js
// Magnolia Memorial Dashboard Tab Navigation
// Handles tab switching, accessibility, and error state focus

function init() {
  // Loading state logic
  var loading = document.getElementById('dashboard-loading');
  var content = document.getElementById('dashboard-content');
  if (loading && content) {
    setTimeout(function () {
      loading.style.display = 'none';
      loading.setAttribute('aria-busy', 'false');
      content.removeAttribute('hidden');
      document.getElementById('dashboard-section').setAttribute('aria-busy', 'false');
      // Focus error for accessibility if present
      var error = content.querySelector('.dashboard-error');
      if (error) error.focus();
    }, 400); // Simulate async, can be 0 for instant
  }

  var nav = document.querySelector('.dashboard-shell__nav');
  if (!nav) return;
  var tabs = Array.from(nav.querySelectorAll('.dashboard-tab'));
  var panels = Array.from(document.querySelectorAll('.dashboard-panel'));

  function activateTab(tab) {
    tabs.forEach(function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      t.tabIndex = t === tab ? 0 : -1;
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('aria-labelledby') !== tab.id;
    });
    // Update URL hash to reflect active tab
    var tabName = tab.id.replace('tab-', '');
    window.history.replaceState(null, null, '#' + tabName);
    // Move focus to panel for accessibility
    var activePanel = panels.find(function (panel) {
      return !panel.hidden;
    });
    if (activePanel) {
      activePanel.focus();
    }
  }

  nav.addEventListener('click', function (e) {
    var tab = e.target.closest('.dashboard-tab');
    if (!tab) return;
    activateTab(tab);
  });

  nav.addEventListener('keydown', function (e) {
    var currentIdx = tabs.findIndex(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    });
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      var nextIdx = (currentIdx + 1) % tabs.length;
      tabs[nextIdx].focus();
      activateTab(tabs[nextIdx]);
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      var prevIdx = (currentIdx - 1 + tabs.length) % tabs.length;
      tabs[prevIdx].focus();
      activateTab(tabs[prevIdx]);
    }
  });

  // Deep-linking: restore tab from URL hash on page load
  if (window.location.hash) {
    var hash = window.location.hash.replace('#', '');
    var tab = tabs.find(function (t) {
      return t.id === 'tab-' + hash;
    });
    if (tab) {
      activateTab(tab);
    } else {
      // Invalid hash, activate first tab
      activateTab(tabs[0]);
    }
  } else {
    // No hash, set URL to first tab
    if (tabs.length > 0) {
      var firstTabName = tabs[0].id.replace('tab-', '');
      window.history.replaceState(null, null, '#' + firstTabName);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

